import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type ConnectSaltoSpaceUserRequest = {
  email: string
  buildingId: number
  saltoUserId: string | null
}

const connectSaltoSpaceUser = async (data: ConnectSaltoSpaceUserRequest) => {
  const response = await authAPI.post('/salto-space/connect', data)
  return response.data
}

export const useConnectSaltoSpaceUser = () =>
  useMutation({
    mutationFn: connectSaltoSpaceUser,
  })
